import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';

import gallery01 from '../images/620871642_18070022141433282_2426916834075027528_n.jpg';
import gallery02 from '../images/628852516_18072554897433282_188541830524266816_n.jpg';
import gallery03 from '../images/645790711_18073614743433282_4600789289098603347_n.jpg';
import gallery04 from '../images/645576954_18074449322433282_4547916857382011719_n.jpg';

const Gallery = () => {
  const { t } = useLanguage();

  const images = [
    gallery01, // Lash closeup
    gallery02, // Studio interior
    gallery03, // Beauty products/branding
    gallery04, // Another lash
  ];

  return (
    <section className="py-24 bg-brand-cream">
      <div className="max-w-7xl mx-auto px-6 mb-12 flex justify-between items-end">
        <div>
          <h2 className="font-serif text-3xl md:text-4xl text-brand-dark mb-4">{t('gallery.title')}</h2>
          <p className="text-brand-muted font-light">{t('gallery.subtitle')}</p>
        </div>
        <a href="#" className="hidden md:inline-block text-brand-taupe hover:text-brand-taupeDark uppercase tracking-widest text-sm font-medium transition-colors">
          {t('gallery.handle')}
        </a>
      </div>

      <div className="w-full overflow-hidden">
        <div className="flex overflow-x-auto hide-scrollbar snap-x snap-mandatory pb-8 px-6 gap-6 md:grid md:grid-cols-4 md:gap-4 md:overflow-visible md:px-6 max-w-7xl mx-auto">
          {images.map((src, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="flex-none w-[80vw] sm:w-[50vw] md:w-auto snap-center"
            >
              <div className="aspect-[4/5] rounded-2xl overflow-hidden">
                <img 
                  src={src} 
                  alt={t('gallery.imageAlt')}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
                />
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
